import { Component, Vector } from '@inter-ikea-core/core';

/**
 * Component added to the scene to create collider boxes along the help lines
 */
export default class HelpLinesColliderBoxesComponent implements Component {
  static id = 3008;
  typeId = HelpLinesColliderBoxesComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  dimensions: Vector[] = [];

  constructor(dimensions: Vector[]) {
    this.dimensions = dimensions;
  }

  eq(other: HelpLinesColliderBoxesComponent) {
    return this.dimensions === other.dimensions;
  }
}
